export enum ContractsTaxiForwardingContractAddRequestModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type ContractsTaxiForwardingContractAddRequestBody = {
  validSince: Date;
  validTo: Date;
  disabled: boolean;
  model: ContractsTaxiForwardingContractAddRequestModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  producerTaxiId: string;
  consumerTaxiId: string;
  displayName?: string;
  priority?: number;
  isPartner?: boolean;
};

type ContractsTaxiForwardingContractAddRequest = {
  validSince: Date;
  validTo: Date;
  disabled: boolean;
  model: ContractsTaxiForwardingContractAddRequestModel;
  distanceRate: number;
  haltingTimeRate: number;
  haltingTimeAfterMinutes: number;
  producerTaxiId: string;
  consumerTaxiId: string;
  displayName?: string;
  priority?: number;
  isPartner?: boolean;
};

export default ContractsTaxiForwardingContractAddRequest;
